import { MacBookWindow } from '@rumblefish/ui/Rumblefish23Theme';
import { scrollToElement } from '../../../utils/handleScroll';
import { contactFormId } from '../const';

export const Hero = () => {
  return (
    <>
      <MacBookWindow
        title={<>Stellar Product Development Services</>}
        description={<>Ready to build on Stellar? Do it with the team of trusted experts!</>}
        buttonText="Let's talk!"
        buttonHandleOnClick={() => scrollToElement(contactFormId)}
        buttonLink="/contact"
        gradient="stellar"
      />
    </>
  );
};
